import type { Process } from "types/types";
import { PnlCategoriesEnum } from "types/enums";
import {
  useExpandedTilesDataForProcess,
  useLatestSegmentForProcess,
} from "../expandedTileUtils";
import { SingleLineModule } from "./ExpandedTileModules";
import styled from "styled-components/macro";
import { useFlightTranslation } from "utils/customHooks/useFlightTranslation";
import { useSettings } from "contexts/SettingsManager/SettingsManager";

/** Expanded Tile module showing operator name */
export function TileTeamSizeModule({ process }: { process: Process }) {
  const expandedTilesData = useExpandedTilesDataForProcess(process.id);
  const teamSize = expandedTilesData?.teamSize;
  const latestSegment = useLatestSegmentForProcess(process.id);
  const pnlCategory = latestSegment?.pnl.category;
  const isUncollected = pnlCategory === PnlCategoriesEnum.uncollected;
  const isLoading = !expandedTilesData && !isUncollected;
  const { tileScaleMultiplier } = useSettings();

  const { translate } = useFlightTranslation();
  return (
    <SingleLineModule
      loading={isLoading}
      data={
        <TileTeamSizeStyles
          className={`tileTeamSizeModule ${
            teamSize ? "team-size" : "no-team-size"
          }`}
          $tileScaleMultiplier={tileScaleMultiplier}
        >
          {teamSize ? (
            <div className="teamSizeText lightText">
              {translate("Team_Size")}
            </div>
          ) : null}
          <div className={`teamSizeValue`}>{teamSize || "-no team size-"}</div>
        </TileTeamSizeStyles>
      }
    />
  );
}

const TileTeamSizeStyles = styled.div<{ $tileScaleMultiplier: number }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0 ${props => 1 * props.$tileScaleMultiplier}em;
  box-sizing: border-box;
  .lightText {
    font-weight: normal;
  }
  &.team-size {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  /* "-no operator-" appears slightly smaller */
  &:not(.team-size) {
    transform: scale(${props => 0.9 * props.$tileScaleMultiplier});
    font-weight: normal;
    .teamSizeValue {
      margin: auto;
    }
  }
`;
